import React from 'react'

function Component3({ name }) {
  return (
    <div className="comp-card">

      <h3>Component 3</h3>
      <h4>{name}</h4>

    </div>
  )
}

export default Component3